export default "__VITE_ASSET__odSQSOO8__"